import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"


export default class extends Controller {
  static values = {
    url: String
  }

  connect() {
    this.select = new TomSelect(this.element, {
      valueField: "id",
      create: false,
      maxOptions: 50,
      maxItems: 1,
      preload: true,
      persist: false,
      closeAfterSelect: true,
      plugins: {
        clear_button: {
          title: 'entfernen',
          className: "clear-button fs-5 ff-special lh-sm",
        }
      },

      render:{
        no_results: function( data, escape ){
          return '<div class="no-results">Keine Einträge gefunden.</div>';
        },
      },

      load: (query, callback) => {
        if (!query.length) return callback()
        const url = `${this.urlValue}?query=${encodeURIComponent(query)}`
        fetch(url)
          .then(res => res.json())
          .then(json => callback(json))
          .catch(() => callback())
      }
    })
  }

  disconnect() {
    if (this.select) this.select.destroy()
  }
}
